import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { NotFound } from "@/components/layout/not-found";
import { PageSpinner } from "@/components/layout/page-spinner";
import { RouteError } from "@/components/layout/route-error";
import { routeTree } from "@/routeTree.gen";

/** Values every route can read in `beforeLoad` / `loader` via `context`. */
export type RouterContext = {
  queryClient: QueryClient;
};

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0, // let TanStack Query own staleness
    scrollRestoration: true,
    defaultNotFoundComponent: NotFound,
    defaultErrorComponent: RouteError,
    defaultPendingComponent: PageSpinner,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
